<div *wlAccessControl="securityElementNames.Profiles_Module; else noAccess"
  class="profile-view flex row-collapse gap-20px">
  <div class="left-content mct-flex mct-col mct-basis-33">
    <wl-profile-notifications class="mct-hide-gt-xs" [profileId]="profileId" (relationshipEvent)="relateNewProfile()">
    </wl-profile-notifications>
    <div class="card-container flex column gap-27px">
      <div class="edit-button-container flex row-collapse">
        <div class="mct-flex mct-row mct-basis-50"
          [ngClass]="profile.Member ? 'drop-button' : 'add-button'">
          <a class="mct-flex mct-justify-center mct-items-center" (click)="disableAddMember ? null : executeAddDrop()"
            *ngIf="profile.Member || !disableAddMember">
            {{ (profile.Member ? 'profiles.view.general.drop-member' : 'profiles.view.general.add-member') | translate |
            uppercase }}
          </a>
          <span class="add-button-disabled mct-flex mct-justify-center mct-items-center" *ngIf="!profile.Member && disableAddMember">
            {{ 'profiles.view.general.add-member' | translate | uppercase }}
          </span>
        </div>
        <div class="edit-button mct-flex mct-row mct-basis-50">
          <a class="mct-flex mct-justify-center mct-items-center" [routerLink]="['/profile/' + profileId.toString() + '/edit']">
            {{ 'profiles.view.general.edit-profile' | translate | uppercase }}
          </a>
        </div>
      </div>
      <div class="profile-name mct-flex mct-col mct-justify-around mct-items-center">
        <div style="margin-bottom: 21px">
          <wl-profile-type-icon [isMember]="profile.Member" [isOrg]="profile.OrgInd" [profileId]="profile.ProfileId"
            [memberTypeIconColor]="profile.MemberTypeIconColor"
            [styleOverrides]="{ 'max-height': '34px', 'max-width': '34px' }"></wl-profile-type-icon>
        </div>
        <h4>{{ profile.ReportName }}</h4>
        <div class="card-field-label">{{ listingCategory ? listingCategory : '&nbsp;' }}</div>
        <div class="mct-flex membership-section mct-justify-around mct-items-stretch">
          <div data-cy="divProfileViewMembershipLevel" *ngIf="membershipLevel != ''"
            [ngClass]="profile.Member ? 'membership-level-member' : 'membership-level-non-member'">
            {{ membershipLevel }}
          </div>
        </div>
      </div>
      <div class="member-info mct-flex mct-row">
        <div class="mct-flex mct-col mct-basis-50">
          <div class="card-field-label">{{ 'profiles.view.general.member-since' | translate | titlecase }}</div>
          <div>{{ memberSince | date : 'longDate' }}</div>
        </div>
        <div class="mct-flex mct-col mct-justify-start mct-items-end mct-basis-50">
          <div class="card-field-label">{{ 'profiles.view.general.profile-id' | translate }}</div>
          <div>{{ profile.ProfileId }}</div>
        </div>
      </div>
      <div class="general-information mct-flex mct-row">
        <div class="mct-flex mct-col mct-basis-50">
          <div class="card-field-label">{{ 'profiles.view.general.profile-status' | translate | titlecase }}</div>
          <div>{{ profile.CustStatus }}</div>
        </div>
        <div class="mct-flex mct-col mct-justify-start mct-items-end mct-basis-50" *ngIf="profile.Title">
          <div class="card-field-label">{{ 'profiles.view.general.title' | translate | titlecase }}</div>
          <div>{{ profile.Title }}</div>
        </div>
      </div>
      <div class="general-information mct-flex mct-col">
        <div class="card-field-label">{{ 'common.personal-information.address' | translate | titlecase }}</div>
        <div>{{ profile.Address1 }}</div>
        <div>{{ profile.Address2 }}</div>
        <div>
          {{ profile.City && (profile.State || profile.Zip) ? profile.City + ', ' : profile.City }} {{ profile.State }}
          {{ profile.Zip }}
        </div>
        <div>{{ profile.County ?? '' }}</div>
        <div *ngIf="!(profile.Country?.trim() === '')">{{ profile.Country }}</div>
      </div>
      <div class="general-information mct-flex mct-col">
        <div class="card-field-label">{{ 'profiles.view.general.email-address' | translate | titlecase }}</div>
        <div>
          <a data-cy="aProfileViewEmail" [attr.href]="'mailto: ' + profile.Email">{{ profile.Email }}</a>
        </div>
      </div>
      <div class="general-information mct-flex mct-col">
        <div class="card-field-label">{{ 'profiles.view.general.phone-numbers.label' | translate | titlecase }}</div>
        <div class="mct-flex mct-row">
          <div class="mct-flex mct-col">
            <div class="card-field-label" *ngIf="profile.WorkPhone">
              {{ 'profiles.view.general.phone-numbers.work' | translate | titlecase }}:&nbsp;
            </div>
            <div class="card-field-label" *ngIf="profile.Fax">{{ 'profiles.view.general.phone-numbers.fax' | translate |
              titlecase }}:</div>
            <div class="card-field-label" *ngIf="profile.HomePhone">
              {{ 'profiles.view.general.phone-numbers.home' | translate | titlecase }}:
            </div>
            <div class="card-field-label" *ngIf="profile.CellPhone">
              {{ 'profiles.view.general.phone-numbers.cell' | translate | titlecase }}:
            </div>
          </div>
          <div class="mct-flex mct-col">
            <div *ngIf="profile.WorkPhone">
              {{ profile.WorkPhone | phone }}
              <span *ngIf="profile.Ext">&nbsp;&nbsp;{{ 'profiles.view.general.phone-numbers.ext' | translate | titlecase
                }} {{ profile.Ext }}</span>
            </div>
            <div *ngIf="profile.Fax">{{ profile.Fax | phone }}</div>
            <div *ngIf="profile.HomePhone">{{ profile.HomePhone | phone }}</div>
            <div *ngIf="profile.CellPhone">{{ profile.CellPhone | phone }}</div>
          </div>
        </div>
      </div>
      <div class="general-information mct-flex mct-col">
        <div class="card-field-label">{{ 'profiles.view.general.social-media' | translate | titlecase }}</div>
        <div class="mct-flex mct-row mct-wrap">
          <div class="social-media-icon" *ngIf="facebook">
            <a [href]="facebook.URL" target="_blank"><img src="/assets/img/social-media-icons/facebook.svg"
                alt="Facebook" /></a>
          </div>
          <div class="social-media-icon" *ngIf="twitter">
            <a [href]="twitter.URL" target="_blank"><img src="/assets/img/social-media-icons/x.svg" alt="Twitter" /></a>
          </div>
          <div class="social-media-icon" *ngIf="linkedIn">
            <a [href]="linkedIn.URL" target="_blank"><img src="/assets/img/social-media-icons/linkedin.svg"
                alt="LinkedIn" /></a>
          </div>
          <div class="social-media-icon" *ngIf="pinterest">
            <a [href]="pinterest.URL" target="_blank"><img src="/assets/img/social-media-icons/sn-pinterest.svg"
                alt="Pinterest" /></a>
          </div>
          <div class="social-media-icon" *ngIf="youTube">
            <a [href]="youTube.URL" target="_blank"><img src="/assets/img/social-media-icons/youtube.svg"
                alt="YouTube" /></a>
          </div>
          <div class="social-media-icon" *ngIf="flickr">
            <a [href]="flickr.URL" target="_blank"><img src="/assets/img/social-media-icons/sn-flickr.svg"
                alt="Flickr" /></a>
          </div>
          <div class="social-media-icon" *ngIf="yelp">
            <a [href]="yelp.URL" target="_blank"><img src="/assets/img/social-media-icons/sn-yelp.svg" alt="Yelp" /></a>
          </div>
          <div class="social-media-icon" *ngIf="openTable">
            <a [href]="openTable.URL" target="_blank"><img src="/assets/img/social-media-icons/sn-opentable.svg"
                alt="OpenTable" /></a>
          </div>
          <div class="social-media-icon" *ngIf="instagram">
            <a [href]="instagram.URL" target="_blank"><img src="/assets/img/social-media-icons/instagram.svg"
                alt="Instagram" /></a>
          </div>
          <div class="social-media-icon" *ngIf="foursquare">
            <a [href]="foursquare.URL" target="_blank"><img src="/assets/img/social-media-icons/sn-foursquare.svg"
                alt="Foursquare" /></a>
          </div>
          <div class="social-media-icon" *ngIf="tripAdvisor">
            <a [href]="tripAdvisor.URL" target="_blank"><img src="/assets/img/social-media-icons/sn-tripadvisor.svg"
                alt="TripAdvisor" /></a>
          </div>
          <div class="social-media-icon" *ngIf="houzz">
            <a [href]="houzz.URL" target="_blank"><img src="/assets/img/social-media-icons/sn-houzz.svg"
                alt="Houzz" /></a>
          </div>
          <div class="social-media-icon" *ngIf="angiesList">
            <a [href]="angiesList.URL" target="_blank"><img src="/assets/img/social-media-icons/sn-angieslist.svg"
                alt="Angie's List" /></a>
          </div>
        </div>
      </div>
      <div class="general-information mct-flex mct-col">
        <div class="card-field-label">
          {{ 'profiles.view.general.website' | translate | titlecase }}
        </div>
        <div>
          <a target="_blank" href="{{ profile.Website | absoluteUrl }}">{{ profile.Website }}</a>
        </div>
      </div>
      <hr *wlAccessControl="'ProfileDetails_Tab'" style="width: 100%; margin-bottom: 36px" />
      <div class="profile-employees mct-flex mct-row">
        <div class="mct-basis-50">
          <h4>{{ profile.EmployeesFT }}</h4>
          <div class="card-field-label">
            {{ 'profiles.view.general.full-time' | translate | titlecase }}<br />{{
            'profiles.view.general.employees' | translate | titlecase
            }}
          </div>
        </div>
        <div class="mct-basis-50">
          <h4>{{ profile.EmployeesPT }}</h4>
          <div class="card-field-label">
            {{ 'profiles.view.general.part-time' | translate | titlecase }}<br />{{
            'profiles.view.general.employees' | translate | titlecase
            }}
          </div>
        </div>
      </div>
      <div *wlAccessControl="'ProfileDetails_Tab'" class="general-information mct-flex mct-col">
        <div class="card-field-label">{{ 'profiles.view.general.sold-by' | translate | titlecase }}</div>
        <div>{{ soldBy ? soldBy : '&nbsp;' }}</div>
      </div>
      <div *wlAccessControl="'ProfileDetails_Tab'" class="general-information mct-flex mct-col">
        <div class="card-field-label">{{ 'profiles.view.general.assigned-to' | translate | titlecase }}</div>
        <div>{{ assignedTo ? assignedTo : '&nbsp;' }}</div>
      </div>
      <hr style="width: 100%" />
      <div class="metrics-button-container">
        <div class="metrics-button mct-flex mct-row mct-basis-100">
          <a class="mct-flex mct-justify-center mct-items-center" (click)="viewEngagementMetricsClick()">
            {{ 'profiles.view.general.view-engagement-metrics' | translate | uppercase }}
          </a>
        </div>
      </div>
    </div>
    <div *wlAccessControl="'ProfileAffiliations_Tab'" class="card-container">
      <wl-profile-view-affiliation [profileId]="profileId"></wl-profile-view-affiliation>
    </div>
    <div class="card-container">
      <wl-profile-view-referral-report [profileId]="profileId"></wl-profile-view-referral-report>
    </div>
    <div *wlAccessControl="'ProfileEvents_Tab'" class="card-container">
      <wl-profile-view-events-activity [orgInd]="profile.OrgInd"
        [profileId]="profileId"></wl-profile-view-events-activity>
    </div>
    <div class="card-container">
      <wl-profile-history [profileId]="profileId"></wl-profile-history>
    </div>
    <ng-container>
      <div *wlAccessControl="'ProfileCommittees_Tab'" class="card-container">
        <wl-profile-view-committees [profileId]="profileId"
          [profileIsOrg]="profile.OrgInd"></wl-profile-view-committees>
      </div>
    </ng-container>
    <div class="card-container">
      <wl-profile-view-web-content [profileId]="profileId"></wl-profile-view-web-content>
    </div>
  </div>
  <div class="right-content mct-flex mct-col mct-basis-66">
    <wl-profile-notifications class="mct-hide-lt-sm" [profileId]="profileId"
      (relationshipEvent)="relateNewProfile()"></wl-profile-notifications>
    <div [hidden]="hideRevenueCard" *wlAccessControl="'ProfileTransactions_Tab'" class="card-container">
      <div *wlAccessControl="'ProfileBilling_Tab'">
        <wl-profile-view-revenue [profileId]="profileId"></wl-profile-view-revenue>
      </div>
    </div>
    <div *wlAccessControl="'ProfileRelated_Profiles_Tab'" class="card-container">
      <wl-profile-view-primary-relations [profileId]="profileId"></wl-profile-view-primary-relations>
    </div>
    <div *wlAccessControl="'ProfileCustom_Info_Tab'" class="card-container">
      <wl-profile-view-custom-fields [profileId]="profileId"></wl-profile-view-custom-fields>
    </div>
    <div *wlAccessControl="'ProfileMember_Activity_Tab'" class="card-container">
      <wl-profile-view-member-activity [profileId]="profileId"></wl-profile-view-member-activity>
    </div>
    <div *wlAccessControl="'ProfileContacts_Tab'" class="card-container">
      <wl-profile-view-recent-contacts [profileId]="profileId"></wl-profile-view-recent-contacts>
    </div>
    <div [hidden]="!hasSalesOpportunities" class="card-container">
      <wl-profile-view-sales-opportunities [profileId]="profileId"></wl-profile-view-sales-opportunities>
    </div>
    <div class="card-container">
      <wl-profile-view-benefits [profileId]="profileId"></wl-profile-view-benefits>
    </div>
    <div class="card-container" *ngIf="showCertifications">
      <wl-profile-view-certifications [profileId]="profileId"></wl-profile-view-certifications>
    </div>
    <div class="card-container">
      <wl-profile-view-tasks [profileId]="profileId"></wl-profile-view-tasks>
    </div>
    <div *ngIf="voterVoiceSettings" class="card-container">
      <wl-profile-view-voter-voice [profileId]="profileId"></wl-profile-view-voter-voice>
    </div>
  </div>
</div>
<ng-template #noAccess>
  {{ 'common.phrases.ya-cant-get-there-from-heah' | translate }}
</ng-template>

<p-dialog modal="true" [(visible)]="showDropModal" [closable]="false" [minY]="350" styleClass="atlas-dialog-s"
  [focusOnShow]="false" [contentStyle]="{ 'max-height': '75vh' }">
  <ng-template pTemplate="header">
    <h4 style="font-weight: normal">
      <span>{{ 'profiles.view.general.drop-member' | translate | ucfirst }} </span>
      <span style="font-weight: bold">{{ profile.ReportName }} </span>
      <span style="color: #999999"> ({{ profile.ProfileId }})</span>
    </h4>
  </ng-template>
  <div class="drop-modal-body">
    <div *ngIf="!dropSettings">
      {{ 'profiles.view.drop-member.no-settings' | translate }}
    </div>
    <div *ngIf="dropSettings">
      <div>
        <p-checkbox name="dropMode" binary="true" [(ngModel)]="autoDrop"></p-checkbox>
        <label style="margin-left: 0.3em">{{ 'profiles.view.drop-member.auto-drop-prompt' | translate | ucfirst
          }}</label>
      </div>
      <div>
        <p-select name="selectedDropType" [options]="memberActivityTypes" placeholder="-- Select --"
          optionLabel="ActivityType" dataKey="ActivityTypeID" [(ngModel)]="selectedDropType" [style]="{ width: '100%' }"
          appendTo="body"></p-select>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="closeDropModal()">{{ 'common.cancel' | translate |
      uppercase }}</button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="dropMember()">{{ 'profiles.view.drop-member.drop' |
      translate | uppercase }}</button>
  </ng-template>
</p-dialog>

<wl-profile-add-as-member [show]="showAddModal" (close)="showAddModal = false" [profile]="profile"
  (saved)="this.loadProfile(true)"></wl-profile-add-as-member>
